import React, { useRef } from 'react';
import About from './about';
import News from './news';
import Service from './service';
import Bio from './bio';
import Awards from './awards';
import SelectedPublications from './publications';

export default function Index() {
  // The news list sizes itself against these two: it may grow until the left column is as tall
  // as the right one, and no further.
  const mainColumnRef = useRef(null);
  const profileRef = useRef(null);

  return (
    <div className="home-layout">
      <div className="home-profile" ref={profileRef}><About /></div>
      <section className="home-main" ref={mainColumnRef}>
        <Bio />
        <SelectedPublications />
        <Service />
        <Awards />
      </section>
      <div className="home-news"><News mainColumnRef={mainColumnRef} profileRef={profileRef} /></div>
    </div>
  );
}
